export default __webpack_public_path__ + "static/media/KPLB-Logo-Lines.9a5fe78d.png";